import { Component, OnInit, ViewEncapsulation, forwardRef, ElementRef, Renderer, Injector } from '@angular/core';
import { UploaderSettings, ToggleOption, BaseAbstractControl } from 'moh-package';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormGroup, FormControl, FormArray } from '@angular/forms';
import { GazzezetService } from '../../../services/general/gazzezet.service';

@Component({
  selector: 'moh-survivors-claim',
  templateUrl: './survivors-claim.component.html',
  styleUrls: ['./survivors-claim.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SurvivorsClaimComponent), multi: true, },
    { provide: NG_VALIDATORS, multi: true, useExisting: forwardRef(() => SurvivorsClaimComponent) }]
})
export class SurvivorsClaimComponent extends BaseAbstractControl implements OnInit {

  courtsList: any[];
  slideToggleOptions: ToggleOption[];
  proofOfClaimDocumentSettings: UploaderSettings = new UploaderSettings();

  constructor(injector: Injector, private gazzezetService: GazzezetService) {

    super(injector);
  }

  ngOnInit() {

    this.initializeFormGroup();

    this.initializeDocumentsSettings();

    this.initializeCourtsList();

    this.slideToggleOptions = [new ToggleOption('כן', true), new ToggleOption('לא', false)];

    super.ngOnInit();
  }

  initializeFormGroup() {

    this.baseAbstractControl = new FormGroup({
      DeceasedDetails: new FormControl('', []),
      Children: new FormArray([new FormControl()]),
      RadiationStartDate: new FormControl(new Date(), []),
      RadiationEndDate: new FormControl(new Date(), []),
      TreatedBy: new FormControl('', []),
      TreatedByAddress: new FormControl('', []),
      DiagnosedBy: new FormControl('', []),
      DiagnosedDate: new FormControl(new Date(), []),
      HadDiedFromTheDecease: new FormControl(false, []),
      ProvingDocuments: new FormArray([new FormControl()]),
      NoOtherClaimConfirm: new FormControl(false, []),
      NoClaimFilledDeclare: new FormControl(false, []),
      WasClaimSubmitted: new FormControl(false, []),
      SubmittedAt: new FormControl(0, []),
      CaseNumber: new FormControl('', []),
      RullingTheCaseDate: new FormControl(new Date(), []),
      RullingTheCaseBy: new FormControl('', [])
    });
  }

  initializeDocumentsSettings() {

    this.proofOfClaimDocumentSettings = {

      allowMimeTypes: ['application/pdf', 'image/bmp', 'image/gif', 'image/tiff', 'image/jpeg', 'image/png'],
      maxFileSize: 10 * 1024 * 1024, //10MB
      queueLimit: 1,
      queueMinLimit: 1,
      hasDescription: true,
      isDescriptionRequired: false,
      isMultiple: false,
      isRequired: true,
      isSigned: false
    }
  }

  initializeCourtsList() {

    this.gazzezetService.getCourtsList().subscribe(
      res => {
        this.courtsList = res;
      },
      error => console.log("error: " + error));
  }

  addChildToArray() {

    (<FormArray>this.baseAbstractControl['controls'].Children).push(new FormControl());
  }

  removeChildFromArray(index) {

    const control = <FormArray>this.baseAbstractControl['controls'].Children;
    control.removeAt(index);
  }

  addDocumentToArray() {

    (<FormArray>this.baseAbstractControl['controls'].ProvingDocuments).push(new FormControl());
  }

  removeDocumentFromArray(index) {

    const control = <FormArray>this.baseAbstractControl['controls'].ProvingDocuments;
    control.removeAt(index);
  }
}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/components/survivors/survivors-claim/survivors-claim.component.ts